import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { AppState } from './app.reducer';
import { environment as env, environment } from '../environments/environment';
import { ApigatewayService } from './common/services/apigateway.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'artico-front';

  viewToast: boolean = false;

  messageToast: String = '';

  pathPolicy: string = 'multiproduct/policy';

  constructor(
    private store: Store<AppState>,
    private translateService: TranslateService,
    private apigatewayService: ApigatewayService
  ) {
    this.loadDatadogScript();
    this.logAppVersion();
    this.translateService.use(this.language);
    this.store.select(state => state.viewToast.toastMessage).subscribe((message) => {
      this.messageToast = message ?? '';
      this.viewToast = !!message;
    });
  }

  ngOnInit() {

    this.apigatewayService.selectAccApiGateway();
  }

  private logAppVersion() {
    // eslint-disable-next-line no-console
    console.log('AppVersion:', env.version);
    // eslint-disable-next-line no-console
    console.log('Country:', env.COUNTRY, 'Env:', env.FRONT_ENV);
  }

  get language() {
    return env.COUNTRY?.toLowerCase() || '';
  }

  loadDatadogScript(): void {
    if (environment.FRONT_ENV !== 'dev' && !window.location.pathname.includes(this.pathPolicy)) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML = `
      window.DD_RUM && window.DD_RUM.init({
        clientToken: '${environment.DATADOG.clientToken}',
        applicationId: '${environment.DATADOG.applicationId}',
        site: 'datadoghq.com',
        service: '${environment.DATADOG.service}',
        env: '${environment.DATADOG.env}',
        version: '${environment.version}',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'allow',
        flushTimeout: 5000, // Retrasa el envío de eventos para evitar bloqueos
        allowFallbackToLocalStorage: true // Guarda eventos en localStorage si hay problemas de red
      });
    `;
      document.head.appendChild(script);
    }
  }
}
